import fly from 'flyio';
import { ElMessage } from 'element-plus';
import siteInfo from "/siteInfo";
import store from '@/store/index.js'
import router from '@/router/index.js'

// 获取token
function getToken() {
  return store.getters['auth/token'] || 'no-token'
}

//获取地址栏指定参数的值
function requestGetUrlParam(strName, strHref, strDefault) {
  if (strHref == null || strHref.length < 1) {
    strHref = window.location.href;
  }
  var intPos = strHref.indexOf("?");
  var strRight = strHref.substr(intPos + 1);
  var arrTmp = strRight.split("&");
  for (var i = 0; i < arrTmp.length; i++) {
    var arrTemp = arrTmp[i].split("=");
    if (arrTemp[0].toUpperCase() === strName.toUpperCase()) return arrTemp[1];
  }
  return strDefault;
}

const isWq = false; //是否构造微擎地址
/* 适配H5端 */
if (!isWq) {
  if (!siteInfo.uniacid) {
    siteInfo.uniacid = requestGetUrlParam('i');
  }
  if (!siteInfo.server_host) {
    siteInfo.server_host = window.location.protocol + '//' + window.location.hostname;
  }
}
//应用访问路径
const distPath = function (url) {
  if (siteInfo.site_dist) {
    return `/${siteInfo.site_dist}/${url}`;
  } else {
    return `/${url}`;
  }
}
//格式化请求路径
const formatUrl = function (url) {
  url = `${siteInfo.app_name}/${url}`;
  if (isWq) {
    url = `${siteInfo.server_host}?i=${siteInfo.uniacid}&union=${siteInfo.union}&v=${siteInfo.app_version}&from=wxapp&c=entry&a=wxapp&do=api&m=${siteInfo.module_name}&s=${url}`;
    return url;
  } else {
    url = `${siteInfo.server_host}/${url}?i=${siteInfo.uniacid}&union=${siteInfo.union}`;
    return url
  }
}
//设置请求数据类型 application/x-www-form-urlencoded,application/json,text/xml,multipart/form-data
const contentType = function (type) {
  if (type == 'json') {
    fly.config.headers['Content-Type'] = 'application/json; charset=utf-8';
  } else if (type == 'xml') {
    fly.config.headers['Content-Type'] = 'text/xml';
  } else if (type == 'file') {
    fly.config.headers['Content-Type'] = 'multipart/form-data';
  } else {
    fly.config.headers['Content-Type'] = 'application/x-www-form-urlencoded';
  }
}
//设置请求基地址
fly.config.baseURL = siteInfo.server_host;
//设置超时时间 毫秒
fly.config.timeout = 30000;
// 配置请求拦截器
fly.interceptors.request.use((config) => {
  config.headers["Authorization"] = getToken();
  return config;
});
//配置响应拦截器
fly.interceptors.response.use(async function (response) {
    let res = response.data;
    
    // 成功响应
    if (res.code === 2000) {
      return res;
    } 
    // 授权异常
    else if (res.code === 4004) {
      ElMessage.error(res.msg || '授权失败，请重新授权');
      setTimeout(() => {
        store.dispatch('auth/logout');
        window.location.href = distPath('license');
      }, 1500);
      return Promise.reject(new Error(res.msg || '授权异常'));
    } 
    // 登录异常
    else if (res.code === 4001) {
      ElMessage.error('登录已过期，请重新登录');
      store.dispatch('auth/logout');
      setTimeout(() => {
        router.push('/login');
      }, 1500);
      return Promise.reject(new Error('登录异常'));
    } 
    // 无操作权限
    else if (res.code === 4003) {
      ElMessage.error(res.msg || '您没有权限执行此操作');
      return Promise.reject(new Error(res.msg || '无操作权限'));
    }
    // 会员权限不足
    else if (res.code === 4003) {
      ElMessage.warning(res.msg || '会员权限不足');
      setTimeout(() => {
        router.push('/user/home');
      }, 1500);
      return Promise.reject(new Error(res.msg || '会员权限不足'));
    }
    // 其他业务错误
    else {
      ElMessage.error(res.msg || '操作失败，请重试');
      return Promise.reject(new Error(res.msg || '业务错误'));
    }
  },
  (err) => {
    //发生网络错误，会走到这里
    let errorMsg = '请求失败，请重试';
    
    if (err.status === 0) {
      errorMsg = '网络连接失败，请检查网络';
    } else if (err.status === 1) {
      errorMsg = '请求超时，请稍后重试';
    } else if (err.status === 500) {
      errorMsg = '服务器错误，请联系管理员';
    } else if (err.status === 404) {
      errorMsg = '请求的资源不存在';
    } else if (err.status === 400) {
      errorMsg = '请求参数错误';
    } else if (err.status === 401) {
      errorMsg = '未授权，请先登录';
      setTimeout(() => {
        store.dispatch('auth/logout');
        router.push('/login');
      }, 1500);
    } else if (err.status === 403) {
      errorMsg = '禁止访问';
    }
    
    ElMessage.error(errorMsg);
    return Promise.reject(err);
  });
//请求接口
const req = {
  //全路径 请求
  async postUrl(url, param, type = '') {
    contentType(type);
    return await fly.post(url, param)
      .then(function (res) {
        //loading.close();
        return res;
      }).catch(function (err) {
        //loading.close();
        //console.log('Error', err);
        return err;
      })
  },
  async post(url, param, type = '') {
    contentType(type);
    url = formatUrl(url);
    //let loading = ElLoading.service();
    return await fly.post(url, param)
      .then(function (res) {
        //loading.close();
        return res;
      }).catch(function (err) {
        //loading.close();
        //console.log('Error', err);
        return err;
      })
  },
  async get(url, param, type = '') {
    contentType(type);
    url = formatUrl(url);
    //let loading = ElLoading.service();
    return await fly.get(url, param)
      .then(function (res) {
        //loading.close();
        return res;
      })
      .catch(function (err) {
        //loading.close();
        //console.log('Error', err);
        return err;
      })
  }
}

export {
  fly,
  req,
  formatUrl,
  distPath
}